module.exports = __webpack_public_path__ + "img/razzo.f0f716b9.png";